export const planomassmarket = {
    namespaced: true,
    state: {
        copyElement: { elt: null, data: null },
        savePlano: { save: true },
        saveModuleEdit: { save: true },
        saveShelfEdit: { save: true },
        dragEndShadeColor: { elt: null, data: null },
        planoPosInit: {},
        zoomComponent: { active: false },
        copyFavorite: { elt: null, data: null },
        copyScratchpad: { elt: null, data: null },
        exportPdf: {}
    },

    getters: {
        onCopyElement(state) {
            return state.copyElement;
        },

        onCopyFavorite(state) {
            return state.copyFavorite;
        },

        onCopyScratchpad(state) {
            return state.copyScratchpad;
        },

        onSavePlano(state) {
            return state.savePlano;
        },

        onSaveModuleEdit(state) {
            return state.saveModuleEdit;
        },

        onSaveShelfEdit(state) {
            return state.saveShelfEdit;
        },

        onDragEndShadeColor(state) {
            return state.dragEndShadeColor;
        },

        onPlanoPositionInit(state) {
            return state.planoPosInit;
        },

        onZoomComponent(state) {
            return state.zoomComponent;
        },

        getZoomComponent(state) {
            return state.zoomComponent;
        },

        onExportPdf(state) {
            return state.exportPdf;
        }
    },

    mutations: {
        DISPATCH_COPY_ELEMENT(state, obj) {
            state.copyElement = obj;
        },

        DISPATCH_COPY_FAVORITE(state, obj) {
            state.copyFavorite = obj;
        },

        DISPATCH_COPY_SCRATCHPAD(state, obj) {
            state.copyScratchpad = obj;
        },

        DISPATCH_SAVE_PLANO(state, save) {
            state.savePlano = save;
        },

        DISPATCH_SAVE_MODULE_EDIT(state, save) {
            state.saveModuleEdit = save;
        },

        DISPATCH_SAVE_SHELF_EDIT(state, save) {
            state.saveShelfEdit = save;
        },

        DISPATCH_DRAG_END_SHADE_COLOR(state, obj) {
            state.dragEndShadeColor = obj;
        },

        DISPATCH_PLANO_POSITION_INIT(state, obj) {
            state.planoPosInit = obj;
        },

        DISPATACH_ZOOM_COMPONENT(state, obj) {
            state.zoomComponent = obj;
        },

        DISPATACH_EXPORT_PDF(state, obj) {
            state.exportPdf = obj;
        }
    },

    actions: {
        dispatchCopyElement(context, obj) {
            context.commit("DISPATCH_COPY_ELEMENT", obj);
        },

        dispatchCopyFavorite(context, obj) {
            context.commit("DISPATCH_COPY_FAVORITE", obj);
        },

        dispatchCopyScratchpad(context, obj) {
            context.commit("DISPATCH_COPY_SCRATCHPAD", obj);
        },

        dispatchDragEndShadeColor(context, obj) {
            context.commit("DISPATCH_DRAG_END_SHADE_COLOR", obj);
        },

        dispatchSavePlano(context, save) {
            context.commit("DISPATCH_SAVE_PLANO", save);
        },

        dispatchSaveModuleEdit(context, save) {
            context.commit("DISPATCH_SAVE_MODULE_EDIT", save);
        },

        dispatchSaveShelfEdit(context, save) {
            context.commit("DISPATCH_SAVE_SHELF_EDIT", save);
        },

        dispatchPlanoPositionInit(context, obj) {
            context.commit("DISPATCH_PLANO_POSITION_INIT", obj);
        },

        dispatchZoomComponent(context, obj) {
            context.commit("DISPATACH_ZOOM_COMPONENT", obj);
        },

        dispatchExportPdf(context, obj) {
            context.commit("DISPATACH_EXPORT_PDF", obj);
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/events/planomassmarket.js